/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import Button from '#lib/components/button.jsx';
import Dialog from '#lib/components/dialog.jsx';
import Combobox from '../routes/manage/itinerary/search/components/combobox.jsx';
import { isString } from '#lib/utils/string.js';
import { useTags } from '../routes/manage/itinerary/hooks/use-tags.js';
import { groupTags } from '../routes/manage/itinerary/search/helper.js';

export function AddTagPanel(props) {
    const { isOpen, onClose, addTag } = props;

    const { tags } = useTags();
    const categories = Object.keys(groupTags(tags));

    const [name, setName] = useState('');
    const [category, setCategory] = useState('');

    const [queryName, setQueryName] = useState('');
    const [queryCategory, setQueryCategory] = useState('');

    const handleChangeQueryCategory = (q) => {
        setError((prev) => ({ ...prev, category: false }));
        if (queryName && !name) setQueryName('');
        setQueryCategory(q);
    };
    const handleChangeQueryName = (q) => {
        setError((prev) => ({ ...prev, name: false }));
        if (queryCategory && !category) setQueryCategory('');
        setQueryName(q);
    };

    const handleSetValueCategory = (v) => {
        setError((prev) => ({ ...prev, category: false }));
        setQueryCategory(v);
        setCategory(v);
        setQueryName('');
        setName('');
    };
    const handleSetValueName = (v) => {
        setError((prev) => ({ ...prev, name: false }));
        setQueryName(v);
        setName(v);
    };

    const handleAddName = () => setName(queryName);
    const handleAddCategory = () => setCategory(queryCategory);

    const filterFn = (query, option) => {
        const stringOpt = isString(option.name) ? option.name : option;
        const stringQuery = isString(query.name) ? query.name : query;
        return isString(stringOpt) ? stringOpt.toLowerCase().includes(stringQuery.toLowerCase()) : true;
    };

    const [error, setError] = useState({});
    const create = (e) => {
        e.preventDefault();
        if (!category) return setError((prev) => ({ ...prev, category: true }));
        if (!name) return setError((prev) => ({ ...prev, name: true }));
        const tag = tags.find((t) => t.name === name);
        addTag({
            id: tag?.id,
            name,
            type: category
        });
        onClose();
    };

    return (
        <Dialog isOpen={isOpen} onClose={() => { }} className="h-screen flex items-center justify-center fixed inset-4">
            <Dialog.Panel static className="min-w-[300px] w-full max-w-[600px] max-h-[80%]">
                <div className="pr-4 mb-3">
                    <Dialog.CloseButton onClick={onClose} />
                    <p className="text-2xl">{_t.search.addTag()}</p>
                </div>
                <form className="w-full flex flex-col gap-4 items-end" onSubmit={create}>
                    <div className="w-full flex gap-4">
                        <Combobox.Full
                            label={_t.edit.fields.category()}
                            placeholder={_t.edit.fields.category()}
                            inPortal={false}
                            query={queryCategory}
                            onQueryChange={handleChangeQueryCategory}
                            onChange={handleSetValueCategory}
                            addValue={handleAddCategory}
                            options={categories}
                            hasError={error.category}
                        />
                        <Combobox.Full
                            label={_t.edit.fields.name()}
                            placeholder={_t.edit.fields.name()}
                            inPortal={false}
                            query={queryName}
                            onQueryChange={handleChangeQueryName}
                            onChange={handleSetValueName}
                            addValue={handleAddName}
                            accessValue={(opt) => opt.name}
                            filterFn={filterFn}
                            options={tags.filter((tag) => (category ? tag.type === category : tag))}
                            hasError={error.name}
                        />
                    </div>
                    <Button look="primary" type="submit">
                        {_t.global.confirm()}
                    </Button>
                </form>
            </Dialog.Panel>
        </Dialog>
    );
}
